export default __webpack_public_path__ + "static/media/SafePal.482d45d2.svg";